import React, { useState } from "react";
import {
  Card,
  CardContent,
  Button,
  Modal,
  Box,
  TextField,
  Stack,
  Typography,
} from "@mui/material";
import { saveSchoolDetails } from "../../api/schoolApi";
import { useAuth } from "../../context/AuthContext"; // ✅ get userId & schoolId here
import { useNavigate } from "react-router-dom";

const AddInstitute = () => {
  const { userId, token } = useAuth(); // ✅ get token from context
const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    school_name: "",
    affiliated_board: "",
    affiliation_number: "",
    logo: null,
    header_image: null,
  });

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData((prev) => ({ ...prev, [name]: files[0] }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  const data = new FormData();
  data.append("school_name", formData.school_name);
  // data.append("user_id", userId); 

  if (formData.affiliated_board)
    data.append("affiliated_board", formData.affiliated_board);
  if (formData.affiliation_number)
    data.append("affiliation_number", formData.affiliation_number);
  if (formData.logo) data.append("logo", formData.logo);
  if (formData.header_image) data.append("header_image", formData.header_image);

  try {
    // Save school
    const response = await saveSchoolDetails(data);
    console.log("✅ School created:", response);

    // Close modal
    handleClose();

    // Redirect to Create Question page
    navigate("/create-question"); // <-- your route path here
  } catch (error) {
    console.error("❌ Error creating school:", error.response || error);
  }
};

  return (
    <>
      <Typography
        variant="subtitle1"
        gutterBottom
        sx={{ fontWeight: 700, fontSize: "1.2rem", mb: 2 }}
      >
        Please complete the following steps to access Question generator.
      </Typography>

      <Box
        sx={{
          width: "100%",
          mx: "auto",
          mt: 8,
          borderRadius: 1,
          border: "2px solid",
          borderColor: "#1976d2",
        }}
      >
        <Card sx={{ borderRadius: 2, boxShadow: 2, p: 2 }}>
          <CardContent sx={{ py: 1, px: 3 }}>
            <Typography
              variant="h5"
              sx={{ fontWeight: 700, color: "#1976d2", my: 1.5 }}
            >
              Add Institute
            </Typography>

            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Add your institute details to create PDF header for you.
            </Typography>

            <Button
              variant="contained"
              onClick={handleOpen}
              sx={{ px: 4, py: 1.5 }}
            >
              Start
            </Button>
          </CardContent>
        </Card>

        {/* Modal Form */}
        <Modal open={open} onClose={handleClose}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 3,
              borderRadius: 2,
            }}
          >
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              Institute Details
            </Typography>

            <form onSubmit={handleSubmit}>
              <Stack spacing={2.5}>
                <TextField
                  fullWidth
                  label="School Name"
                  name="school_name"
                  value={formData.school_name}
                  onChange={handleChange}
                  required
                  size="small"
                />

                <TextField
                  fullWidth
                  label="Address Line 1"
                  name="affiliated_board"
                  value={formData.affiliated_board}
                  onChange={handleChange}
                  size="small"
                />

                <TextField
                  fullWidth
                  label="Address Line 1"
                  name="affiliation_number"
                  value={formData.affiliation_number}
                  onChange={handleChange}
                  size="small"
                />

                {/* Logo Upload */}
                <Button variant="outlined" component="label">
                  Upload Logo
                  <input
                    type="file"
                    name="logo"
                    hidden
                    onChange={handleFileChange}
                  />
                </Button>

                {/* Header Image Upload */}
                <Button variant="outlined" component="label">
                  Upload Header Image
                  <input
                    type="file"
                    name="header_image"
                    hidden
                    onChange={handleFileChange}
                  />
                </Button>

                <Stack direction="row" spacing={2} justifyContent="flex-end">
                  <Button variant="outlined" onClick={handleClose}>
                    Cancel
                  </Button>
                  <Button type="submit" variant="contained">
                    Save
                  </Button>
                </Stack>
              </Stack>
            </form>
          </Box>
        </Modal>
      </Box>
    </>
  );
};

export default AddInstitute;
